import { render, staticRenderFns } from "./AcessoPermissaoManager.vue?vue&type=template&id=63ba6a25&scoped=true"
import script from "./AcessoPermissaoManager.vue?vue&type=script&lang=js"
export * from "./AcessoPermissaoManager.vue?vue&type=script&lang=js"
import style0 from "./AcessoPermissaoManager.vue?vue&type=style&index=0&id=63ba6a25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ba6a25",
  null
  
)

export default component.exports